import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  deleteReport,
  downloadReport,
  getReports,
  storeExports,
} from "./service";
import { useNavigate } from "react-router";
import { useToast } from "../../../context/toast/ToastContext";

export const useGetReports = ({
  type,
  page,
}: {
  type?: string;
  page: number;
}) => {
  const navigate = useNavigate();

  return useQuery({
    enabled: type !== undefined,
    queryKey: ["reports", type, page],
    queryFn: () => getReports({ type, page }),
    onSuccess: (e) => {
      if (e.data.error_message === "Token has expired!") {
        localStorage.clear();
        navigate("/login");
        window.location.reload();
      }
    },
  });
};

export const useStoreExports = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      end_date,
      export_type,
      id,
      start_date,
    }: {
      export_type: string;
      id?: number | number[];
      start_date?: string;
      end_date?: string;
    }) => storeExports({ end_date, export_type, id, start_date }),
    onSuccess: (e: any) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil menambahkan Export baru");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};

export const useDownloadReport = ({ id }: { id: number }) => {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["download-report", id],
    queryFn: () => downloadReport({ id }),
    onSuccess: (e) => {
      if (e.data.error_message === "Token has expired!") {
        localStorage.clear();
        navigate("/login");
        window.location.reload();
      }
    },
  });
};

export const useDeleteReport = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => deleteReport({ id }),
    onSuccess: (e: any) => {
      if (e.data.statusCode === 200) {
        toast.show("Berhasil menghapus Report");
        queryClient.invalidateQueries();
      } else if (e.data.statusCode === 400) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      } else if (e.data.statusCode === 101) {
        const msg =
          e.data.error_message ||
          "Terjadi kesalahan mohon coba beberapa saat lagi";
        toast.show(msg);
      }
    },
  });
};
